import React from "react";

function Others() {
  return (
    <div>
      <div>
        <p className="wallet_other" style={{ marginTop: "20px" }}>
          Please come here later.
          <br /> Soon some craziness will <br /> be come here
        </p>
      </div>
    </div>
  );
}

export default Others;
